import { faMessages } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Colors } from '@vetahealth/fishing-gear/colors'
import { Badge, Button, Tooltip } from 'antd'

import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { useChatStore } from '../../stores/chat'
import { usePatientStore } from '../../stores/patient'
import { Chat } from './Chat'

const Wrap = styled.div`
  position: relative;
`

export function OpenChat(): React.ReactNode {
  const [isChatOpen, unreadChatMessages, setIsChatOpen] = useChatStore((state) => [
    state.isChatOpen,
    state.unreadChatMessages,
    state.setIsChatOpen,
  ])
  const [patient] = usePatientStore((state) => [state.patient])
  const { t } = useTranslation()

  const hasNewMessage = unreadChatMessages.some((message) => message.userId === patient?.id)

  return (
    <Wrap>
      <Tooltip title={hasNewMessage ? t('chat.newMessages') : t('chat.title')}>
        <Badge dot={hasNewMessage} color={Colors.ruby600}>
          <Button shape="circle" onClick={() => setIsChatOpen(true)}>
            <FontAwesomeIcon icon={faMessages} />
          </Button>
        </Badge>
      </Tooltip>
      {isChatOpen && <Chat />}
    </Wrap>
  )
}
